// Gen-3 design tokens (Elevated + Dark). The v3 component set OWNS its palette
// so it never depends on the app's legacy theme.colors shape (which varies by
// provider and may lack `card`/`ink`/`label`). It only relies on `theme.name`,
// which every ThemeProvider in this app sets. Source values come straight from
// the gen-3 design: Users & Accounts.html :root[data-theme="light-soft"|"dark"].

const ORANGE = '250, 70, 22';

const PALETTES = {
  light: {
    // Elevated
    page: '#eaeef3',
    card: '#ffffff',
    inset: '#f3f5f8',
    head: '#fafbfd',
    text: '#1f2a30',
    sub: '#647483',
    label: '#64748b',
    faint: 'rgba(31, 42, 48, 0.42)',
    ink: '31, 42, 48',
    border: 'rgba(31, 42, 48, 0.1)',
    line: 'rgba(31, 42, 48, 0.07)',
    fieldBorder: 'rgba(31, 42, 48, 0.12)',
    shadowCard: '0 8px 24px rgba(23, 37, 69, 0.12)',
    shadowPop: '0 18px 50px rgba(23, 37, 69, 0.22)',
    halo: '0 0 0 2px rgba(250, 70, 22, 0.09)',
    primary: '#fa4616',
  },
  dark: {
    // Dark
    page: '#0f0f23',
    card: '#1a1a2e',
    inset: '#14142a',
    head: '#16162b',
    text: '#ffffff',
    sub: 'rgba(255, 255, 255, 0.55)',
    label: 'rgba(255, 255, 255, 0.5)',
    faint: 'rgba(255, 255, 255, 0.38)',
    ink: '255, 255, 255',
    border: 'rgba(255, 255, 255, 0.1)',
    line: 'rgba(255, 255, 255, 0.07)',
    fieldBorder: 'rgba(255, 255, 255, 0.12)',
    shadowCard: 'none',
    shadowPop: '0 18px 48px rgba(0, 0, 0, 0.5)',
    halo: '0 0 0 2px rgba(250, 70, 22, 0.14)',
    primary: '#fa4616',
  },
};

// Resolve the active palette. Defaults to light when no theme / unknown name,
// so a missing ThemeProvider degrades gracefully instead of throwing.
export const tokens = (theme) =>
  PALETTES[theme && theme.name === 'dark' ? 'dark' : 'light'];

// Type family from the design's colors_and_type.css — the system stack, no
// webfonts. The legacy shell cascades Barlow Condensed/Roboto; v3 opts out.
export const FONT_SYSTEM =
  'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

// Brand orange at an arbitrary alpha (theme-independent).
export const orange = (alpha) => `rgba(${ORANGE}, ${alpha})`;

// Ink (foreground) at an arbitrary alpha — the design's primary way of
// deriving borders, hovers, and muted text.
export const inkA = (theme, alpha) => `rgba(${tokens(theme).ink}, ${alpha})`;
